import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { type MergedState, useMergedStates } from 'src/app/shared/hooks/state';
import { getQueryStringSingleValue } from 'src/app/shared/utils/query';

import { prefetchLocationSitemapPageDataFromApi, useLocationSitemapPageDataFromApi } from './pageData';

export type LocationSitemapPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useLocationSitemapPageDataFromApi>[0];
}>;

export type LocationSitemapPageCombinedState = MergedState<ReturnType<typeof useLocationSitemapPageDataFromApi>>;

export function usePageContext(
	prefetchedData?: LocationSitemapPagePrefetchedContext,
): LocationSitemapPageCombinedState {
	const stateCode = useQueryParamValue('state_code');
	return useMergedStates(useLocationSitemapPageDataFromApi(prefetchedData?.pageData, { stateCode }));
}

export async function prefetchPageContext(context: PrefetchContext): Promise<LocationSitemapPagePrefetchedContext> {
	const stateCode = getQueryStringSingleValue(context.query, 'state_code');
	const [pageData] = await Promise.all([prefetchLocationSitemapPageDataFromApi(context, { stateCode })]);

	return { pageData };
}

export type LocationSitemapPagePrefetchedDataProps = PrefetchedDataProps<LocationSitemapPagePrefetchedContext>;
